import { connect } from 'react-redux';
import DistributionPartnerUser from '../../components/account/DistributionPartnerUser';
import type { AppState } from '../../reducers';

const mapStateToProps = (state: AppState) => ({
  distributionPartnerUser: state.distributionPartnerUser
});

const mapDispatchToProps = () => ({});

export type DistributionPartnerUserPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type DistributionPartnerUserPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DistributionPartnerUser);
